import React, { useState, useEffect } from 'react';
import { TabBar } from 'antd-mobile';
import { CategoryModel } from '../models/categoryModel';
import '../styles/BottomTabBar.css'

const BottomTabBar = ({ activeCategory, onTabChange }) => {
  const [categories, setCategories] = useState([]);

  // 加载分类数据
  useEffect(() => {
    const loadCategories = async () => {
      try {
        let data = await CategoryModel.getCategories({});
        
        console.log('Tab分类数据加载成功', data);
        setCategories(data ?? []);
      } catch (err) {
        console.error('Tab分类数据加载失败', err);
      }
    };

    loadCategories();
  }, []);

  // 渲染Tab图标和文字
  // const renderTabContent = (category) => {
  //   const isActive = activeCategory === category.id;
    
  //   return (
  //     <div style={{
  //       display: 'flex',
  //       flexDirection: 'column',
  //       alignItems: 'center',
  //       padding: '8px 0', // 垂直内边距，控制图标与文字整体高度
  //     }}>
  //       {/* 图标部分 */}
  //       <div style={{ marginBottom: 2 }}> {/* 图标与文字的间距 */}
  //         {category.icon ? (
  //           <img
  //             src={category.icon}
  //             alt={category.name}
  //             style={{
  //               width: '22px',
  //               height: '22px',
  //               objectFit: 'contain',
  //               // 未选中时白色，选中时蓝色（通过滤镜处理图片）
  //               filter: isActive ? 'none' : 'brightness(0) invert(1)',
  //             }}
  //           />
  //         ) : (
  //           // 默认SVG图标
  //           <svg
  //             xmlns="http://www.w3.org/2000/svg"
  //             width="22"
  //             height="22"
  //             viewBox="0 0 24 24"
  //             fill="none"
  //             stroke={isActive ? '#2563eb' : '#ffffff'} // 选中蓝色，未选中白色
  //             strokeWidth="2"
  //             strokeLinecap="round"
  //             strokeLinejoin="round"
  //           >
  //             <rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect>
  //             <circle cx="8.5" cy="8.5" r="1.5"></circle>
  //             <polyline points="21 15 16 10 5 21"></polyline>
  //           </svg>
  //         )}
  //       </div>
        
  //       {/* 文字部分 */}
  //       {/* <span style={{
  //         fontSize: '12px',
  //         color: isActive ? '#2563eb' : '#ffffff', // 选中蓝色，未选中白色
  //         fontWeight: isActive ? 'bold' : 'normal',
  //       }}>
  //         {category.name}
  //       </span> */}
  //     </div>
  //   );
  // };

  return (
    <div
      style={{
        position: 'fixed', // 固定在底部
        bottom: 0,
        left: 0,
        right: 0,
        // height: '60px', // 导航栏高度
        zIndex: 10, // 确保在内容上方
        backgroundColor: 'white', //'#aaaaaa',
      }}>
    <TabBar
      activeKey={activeCategory}
      onChange={onTabChange}
    >
      {categories?.map(item => (
        <TabBar.Item key={item.id}
          title={item.name}
          icon={
          item.icon ? (
            <img
              src={item.icon}
              style={{
                width: '1em',
                height: '1em',
                objectFit: 'contain',
                // 未选中时白色，选中时蓝色（通过滤镜处理图片）
                filter: activeCategory === item.id ? 'none' : 'grayscale(100%)',
              }}
            />
          ) : (
            // 默认SVG图标
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 24 24"
              fill="none"
              stroke={activeCategory === item.id ? '#2563eb' : '#ffffff'} // 选中蓝色，未选中白色
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect>
              <circle cx="8.5" cy="8.5" r="1.5"></circle>
              <polyline points="21 15 16 10 5 21"></polyline>
            </svg>
          )} />
      ))}
    </TabBar>
    </div>
  )

  // return (
  //   <Tabs
  //     value={activeCategory}
  //     onChange={onTabChange}
  //     // 底部导航样式
  //     style={{
  //       position: 'fixed', // 固定在底部
  //       bottom: 0,
  //       left: 0,
  //       right: 0,
  //       height: '60px', // 导航栏高度
  //       zIndex: 10, // 确保在内容上方
  //       backgroundColor: '#aaaaaa',
  //     }}
  //     // Tab栏容器样式
  //     tabBarStyle={{
  //       backgroundColor: '#aaaaaa', // 深色背景
  //       borderTop: '1px solid #444', // 顶部分隔线
  //       display: 'flex',
  //       justifyContent: 'space-around',
  //       padding: '0',
  //     }}
  //     // 单个Tab的样式
  //     tabStyle={{
  //       flex: 1, // 平均分配宽度
  //       padding: '0',
  //     }}
  //     activeLineMode={'none'}
  //     // 隐藏默认选中下划线（用颜色区分选中状态）
  //     // activeLineStyle={{ display: 'none' }}
  //   >
  //     {categories.map((category) => (
  //       <Tabs.Tab
  //         key={category.id}
  //         title={renderTabContent(category)} // 自定义Tab内容（图标+文字）
  //         style={{
  //           padding: '0', // 去掉默认的内边距
  //         }}
  //       />
  //     ))}
  //   </Tabs>
  // );
};

export default BottomTabBar;